export default {
  name: "国际医学部",
  index: {
    title: "国际医学部简介",
    navs: [
      {icon: require('@/page/gjyxb/assets/ch/就诊预约入口@2x.png')},
      {icon: require('@/page/gjyxb/assets/ch/保险公司名单@2x.png')}
    ],
    notice: '温馨提示：'
  },
  introduce: {
    title: "国际医学部简介"
  },
  picc: {
    title: '保险公司名单',
    notice: '请与您的保险公司联系或自行核对我院医疗直付合作保险公司名单，确保您的保险可以在我院国际医学部门诊全额直付医疗费用。'
  },
  pre: {
    title: '就诊预约',
    btn: '就诊申请表'
  },
  form1: {
    title: '就诊预约',
    sexes: ['男', '女'],
    errorMsg: '请填写',
    yzmError: '验证码错误',
    phoneErrorMsg: '手机号码格式不正确',
    nameRuleMsg: '超出字数上限',
    next: '下一步',
    form: {
      name: "患者姓名",
      namePlaceholder: '请输入',
      sex: '性别',
      birthday: '出生日期',
      selectPlaceholder: '请选择',
      country: '国家/地区',
      zj: '护照/通行证/身份证号码',
      bah: '浙大二院病案号（如有）',
      address: '国内常住地址'
    }
  },
  form2: {
    title: '就诊预约',
    next: '下一步',
    form: {
      t1: '国内联系方式',
      phone: "手机号码",
      namePlaceholder: '请输入',
      email: '电子邮件',
      t2: '紧急联系人',
      name: '姓名',
      gx: '与患者关系',
      selectPlaceholder: '请选择',
      mobile: '电话号码'
    }
  },
  form3: {
    title: '就诊预约',
    next: '提交',
    success: '提交成功',
    form: {
      date: "预约日期",
      namePlaceholder: '请输入',
      ks: '预约科室',
      yzm: '输入验证码',
      ys: '首选医生',
      ms: '病情描述',
      selectPlaceholder: '请选择',
      placeholder: '请描述您的就诊原因/症状表现'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/ch.js